import { render, staticRenderFns } from "./DecisionEditor.vue?vue&type=template&id=1fc3d90c&scoped=true&"
import script from "./DecisionEditor.vue?vue&type=script&lang=ts&"
export * from "./DecisionEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DecisionEditor.vue?vue&type=style&index=0&id=1fc3d90c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc3d90c",
  null
  
)

export default component.exports